'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n'], ['\n  color: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _tooltip = require('../tooltip/tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } // TODO: Implement wishlist support

var Button = _styledComponents2.default.button(_templateObject, function (props) {
  return props.color;
});

/** @class AddToWishlistButton
  * A button to manage adding and removing
  * products from the visitor's wishlist.
  */

var AddToWishlistButton = function (_Component) {
  _inherits(AddToWishlistButton, _Component);

  /** @constructor
    * Creates a new instance of AddToWishlistButton
    * for the specified product, and determines
    * if the product is already in the wishlist.
    */
  function AddToWishlistButton(props) {
    _classCallCheck(this, AddToWishlistButton);

    var _this = _possibleConstructorReturn(this, (AddToWishlistButton.__proto__ || Object.getPrototypeOf(AddToWishlistButton)).call(this, props));

    _this.state = {
      onList: true //window.vexpo.showbag.includes(props.content)
    };
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  /** @method handleClick
    * Event handler for adding or removing the product
    * from the wishlist.
    */


  _createClass(AddToWishlistButton, [{
    key: 'handleClick',
    value: function handleClick() {
      var _this2 = this;

      if (this.state.inBag) {
        window.vexpo.wishlist.remove(this.props.content).then(function () {
          return _this2.setState({ inBag: false });
        });
      } else {
        window.vexpo.wishlist.add(this.props.content).then(function () {
          return _this2.setState({ inBag: true });
        });
      }
    }
    /** @method render
      * Renders the AddToWishlistButton with the
      * appropriate message for if the button will
      * add or remove the product from the wishlist.
      */

  }, {
    key: 'render',
    value: function render() {
      var message = this.state.onList ? "Remove From Wishlist" : "Add To Wishlist";
      var color = this.state.onList ? "orange" : "green";
      return _react2.default.createElement(
        _tooltip2.default,
        { text: message },
        _react2.default.createElement(
          Button,
          { color: color, onClick: this.handleClick },
          _react2.default.createElement(_reactFontawesome2.default, { name: 'gift', size: '2x' })
        )
      );
    }
  }]);

  return AddToWishlistButton;
}(_react.Component);

exports.default = AddToWishlistButton;


AddToWishlistButton.propTypes = {
  productID: _propTypes2.default.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/content/add-to-wishlist-button.js
// module id = 1330
// module chunks = 0